var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisabledVisibleGrayCommandcenter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "disabled_visible_blue_1_",
    "data-name": "disabled_visible_blue (1)",
    d: "M16,15a5.693,5.693,0,0,1,4.75,2.5,5.762,5.762,0,0,1-9.5,0A5.693,5.693,0,0,1,16,15Zm0-2a7.538,7.538,0,0,0-7,4.5A7.538,7.538,0,0,0,16,22a7.538,7.538,0,0,0,7-4.5A7.538,7.538,0,0,0,16,13Zm0,6a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,19Zm4.99-6.66c.01-.11.01-.23.01-.34A10,10,0,1,0,9.96,21.95a9.343,9.343,0,0,1-2.32-2.68A8.01,8.01,0,0,1,3,12,7.9,7.9,0,0,1,4.69,7.1l5.66,5.66a9.169,9.169,0,0,1,1.82-1L6.1,5.69A7.9,7.9,0,0,1,11,4a7.994,7.994,0,0,1,7.98,7.45A9.311,9.311,0,0,1,20.99,12.34Z",
    transform: "translate(-1 -2)",
    fill: "#7a89a0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledVisibleGrayCommandcenter);
export default __webpack_public_path__ + "static/media/disabled_visible_gray_commandcenter.8b34a7cd8ec19a4939f379ee9d841445.svg";
export { ForwardRef as ReactComponent };